export default __webpack_public_path__ + "static/media/15_tag_with-kitchen.27676c6b.svg";